// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Sorry, but this competition is not offered in your location.`
};

const de_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Entschuldigung, aber dieses Gewinnspiel ist in deiner Region nicht verfügbar.`
};

const es_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Lo sentimos, pero esta competencia no está disponible en tu ubicación.`
};

const fr_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Désolé, mais ce concours n'est pas offert dans votre région.`
};

const fi_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Valitettavasti tätä kilpailua ei ole saatavilla sijaintisi perusteella.`
};

const hi_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `क्षमा करें, यह प्रतियोगिता आपके स्थान पर उपलब्ध नहीं है।`
};

const ja_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `申し訳ありませんが、このコンテストはお住まいの地域では提供されていません。`
};

const nl_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Sorry, maar deze wedstrijd wordt niet aangeboden in jouw locatie.`
};

const pt_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Desculpe, mas este concurso não está disponível na sua região.`
};

const ro_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Ne pare rău, dar acest concurs nu este disponibil în regiunea dvs.`
};

const th_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `ขออภัย แต่การแข่งขันนี้ไม่ได้เปิดให้บริการในพื้นที่ของคุณ`
};

const ur_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `معذرت، لیکن یہ مقابلہ آپ کے علاقے میں پیش نہیں کیا جاتا۔`
};

const zh_hant1_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `抱歉，此競賽未在您所在的地區提供。`
};

const da_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Beklager, men denne konkurrence tilbydes ikke i din lokation.`
};

const it_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Spiacenti, ma questa competizione non è disponibile nella tua zona.`
};

const vn_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Xin lỗi, nhưng cuộc thi này không có sẵn tại khu vực của bạn.`
};

const ko_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `죄송하지만 이 경품 이벤트는 귀하의 지역에서 제공되지 않습니다.`
};

const tr_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Üzgünüz, ancak bu yarışma bulunduğunuz bölgede sunulmamaktadır.`
};

const lv_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Atvainojiet, bet šī sacensība netiek piedāvāta jūsu atrašanās vietā.`
};

const ar_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `عذراً، هذه المسابقة غير متاحة في موقعك.`
};

const bs_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Izvinjamo se, ali ova nagradna igra nije dostupna na vašoj lokaciji.`
};

const sl_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Oprostite, ampak to tekmovanje ni na voljo na vaši lokaciji.`
};

const id_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Maaf, kompetisi ini tidak tersedia di lokasi Anda.`
};

const sv_widget_not_offered_in_location = /** @type {(inputs: {}) => string} */ () => {
	return `Tyvärr, denna tävling erbjuds inte i din plats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_not_offered_in_location = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_not_offered_in_location(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_not_offered_in_location", locale)
	if (locale === "en") return en_widget_not_offered_in_location(inputs)
	if (locale === "de") return de_widget_not_offered_in_location(inputs)
	if (locale === "es") return es_widget_not_offered_in_location(inputs)
	if (locale === "fr") return fr_widget_not_offered_in_location(inputs)
	if (locale === "fi") return fi_widget_not_offered_in_location(inputs)
	if (locale === "hi") return hi_widget_not_offered_in_location(inputs)
	if (locale === "ja") return ja_widget_not_offered_in_location(inputs)
	if (locale === "nl") return nl_widget_not_offered_in_location(inputs)
	if (locale === "pt") return pt_widget_not_offered_in_location(inputs)
	if (locale === "ro") return ro_widget_not_offered_in_location(inputs)
	if (locale === "th") return th_widget_not_offered_in_location(inputs)
	if (locale === "ur") return ur_widget_not_offered_in_location(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_not_offered_in_location(inputs)
	if (locale === "da") return da_widget_not_offered_in_location(inputs)
	if (locale === "it") return it_widget_not_offered_in_location(inputs)
	if (locale === "vn") return vn_widget_not_offered_in_location(inputs)
	if (locale === "ko") return ko_widget_not_offered_in_location(inputs)
	if (locale === "tr") return tr_widget_not_offered_in_location(inputs)
	if (locale === "lv") return lv_widget_not_offered_in_location(inputs)
	if (locale === "ar") return ar_widget_not_offered_in_location(inputs)
	if (locale === "bs") return bs_widget_not_offered_in_location(inputs)
	if (locale === "sl") return sl_widget_not_offered_in_location(inputs)
	if (locale === "id") return id_widget_not_offered_in_location(inputs)
	if (locale === "sv") return sv_widget_not_offered_in_location(inputs)
	return "widget_not_offered_in_location"
};